import React from 'react'

import classNames from 'classnames'

import './MenuSheet.scss'

type Position = 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'

export interface MenuSheetProps {
  isOpen: boolean
  className?: string
  panelClassName?: string
  position?: Position
  panelRef?: React.Ref<HTMLDivElement>
  panelStyle?: React.CSSProperties
  onBackdropClick?: (e: React.MouseEvent) => void
  onMobileCloseClick?: (e: React.MouseEvent) => void
  children: React.ReactNode
}

export const MenuSheet: React.FC<MenuSheetProps> = ({
  isOpen,
  className,
  panelClassName,
  position = 'bottom-left',
  panelRef,
  panelStyle,
  onBackdropClick,
  onMobileCloseClick,
  children,
}) => {
  if (!isOpen) return null

  return (
    <>
      <div
        className={classNames('o-menu-sheet-backdrop', className)}
        onClick={onBackdropClick}
      />
      <div
        ref={panelRef}
        className={classNames(
          'o-menu-sheet-panel',
          `pos-${position}`,
          panelClassName,
        )}
        style={panelStyle}
      >
        <div
          className="o-menu-sheet-mobile-close"
          role="button"
          aria-label="Close menu"
          onClick={onMobileCloseClick}
        />
        {children}
      </div>
    </>
  )
}

export default MenuSheet
